import { useClientFuelHistoryEvents } from "../store";
import {
  NavigationHistoryPath,
  Transaction,
  TransactionWithType,
} from "../types";
import {
  point as createTurfPoint,
  lineString as lineStringTurf,
} from "@turf/helpers";
import nearestPointOnLine from "@turf/nearest-point-on-line";

export const useGetHistoryWithClientEventOnRoute = (
  navigationHistoryPath: NavigationHistoryPath[]
) => {
  const clientFuelEvents = useClientFuelHistoryEvents();

  let foundEvents: Transaction[] = [];

  return navigationHistoryPath.reduce(
    (acc, item) => {
      const { locations } = item;
      const [startLocation, endLocation] = locations;

      var lineString = lineStringTurf([
        [startLocation.longitude, startLocation.latitude],
        [endLocation.longitude, endLocation.latitude],
      ]);

      const clientEventsOnPath = clientFuelEvents.filter((item) => {
        if (foundEvents.find(({ date }) => date === item.date)) {
          return false;
        }
        const { latitude, longitude } = item;
        const turfPoint = createTurfPoint([longitude, latitude]);
        const {
          properties: { dist },
        } = nearestPointOnLine(lineString, turfPoint, { units: "kilometers" });
        return dist ? dist < 0.1 : false;
      });
      foundEvents = foundEvents.concat(clientEventsOnPath);

      if (clientEventsOnPath.length > 0) {
        acc = acc.concat(clientEventsOnPath);
      }
      acc.push(item);
      return acc;
    },
    [] as Array<NavigationHistoryPath | TransactionWithType>
  );
};
